import { useEffect } from 'react';
import { Contact } from '@ui/sections';
import { site } from '@content/site';
import { contactCopy } from '@content/ui-strings';

export function ContactRoute() {
  useEffect(() => {
    document.title = `Contact · ${site.seo.title.split(' · ')[0] ?? 'Alison Haire'}`;
  }, []);

  return (
    <Contact
      email={site.links['email'] ?? ''}
      linkedinHref={site.links['linkedin'] ?? '#'}
      githubHref={site.links['github'] ?? '#'}
      xHref={site.links['x'] ?? '#'}
      xHandle={site.links['xhandle'] ?? ''}
      resumeHref={site.links['resume'] ?? '/resume.pdf'}
      bookingHref={site.links['booking'] ?? site.links['calendly'] ?? '#'}
      bookingEmbedSrc={site.links['bookingEmbed'] ?? ''}
      copy={contactCopy}
    />
  );
}
